import { Mode } from 'light-component';
import { lang } from 'zf-infra';
import styles from '../style.module.less';
import { ColumnAction } from './action';
import type { CSSProperties, ReactElement } from 'react';
import type { THeadProps } from './types';

export function THead(props: THeadProps): ReactElement | null {
  if (props.mode !== Mode.DESIGN) {
    return null;
  }

  const columns = lang.range('A'.charCodeAt(0), 'A'.charCodeAt(0) + props.cols);
  return (
    <thead>
      <tr>
        <td />
        {columns.map((char, index) => {
          // 尝试在option的第一行里，获取列宽度信息
          const option = props.option[0][index] ?? {};
          const style: CSSProperties = {
            width: (option.width == null || option.width.length) === 0 ? 'unset' : option.width,
            minWidth: 80
          };

          // 生成列标题：A, B, C, D, ...
          const title = String.fromCharCode(char);
          return (
            <td className={styles.dropdown} style={style} key={title}>
              <ColumnAction
                index={index}
                length={props.cols}
                option={{ title, width: option.width, field: option.field }}
                onAction={props.onChange}
                type={props.type}
              />
            </td>
          );
        })}
      </tr>
    </thead>
  );
}
